(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fsx-product-options"]) return;
  try {
    
  if (!customElements.get('fsx-product-options')) {
    customElements.define('fsx-product-options', class extends HTMLElement {
      connectedCallback() {
        this.words = Object.fromEntries(Array.from(this.querySelectorAll('[data-key]'), el => [el.dataset.key, el.textContent]));
        this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
        this.scope = document.getElementById('MainContent');
        if (!this.scope) return;
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.scope, { childList: true, subtree: true, characterData: true });
        this.scope.addEventListener('change', this.schedule);
        this.scope.addEventListener('click', this.schedule);
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.scope?.removeEventListener('change', this.schedule);
        this.scope?.removeEventListener('click', this.schedule);
        cancelAnimationFrame(this.frame);
      }
      write(el, value) { if (el && el.textContent !== value) el.textContent = value; }
      update() {
        const app = this.scope.querySelector('.gpo-app');
        if (!app) return;
        const w = this.words;
        if (!app.querySelector('.fsx-option-intro')) {
          const intro = document.createElement('div'); intro.className = 'fsx-option-intro';
          const title = document.createElement('strong'); title.textContent = w.heading;
          const help = document.createElement('p'); help.textContent = w.intro;
          intro.append(title, help); app.prepend(intro);
        }
        const mappings = {
          'player version': [w.version, w.player, w.standard, w.player_help],
          'flocage': [w.flocage, w.flocage, w.no_flocage, w.flocage_help],
          'short': [w.short, w.short, w.no_short, w.short_help],
          'manche longue': [w.sleeves, w.long, w.short_sleeves, w.sleeves_help]
        };
        for (const input of app.querySelectorAll('input[type="radio"][data-type="buttons"]')) {
          const config = mappings[input.name.trim().toLowerCase()];
          if (!config) continue;
          const field = input.closest('.gpo-element');
          const wrapper = input.closest('.gpo-ov-wrapper');
          const label = input.parentElement.querySelector('label');
          if (!field || !wrapper || !label || wrapper.querySelectorAll('input[type="radio"]').length !== 1) continue;
          this.write(field.querySelector('.gpo-label .label-content'), config[0]);
          for (const text of label.querySelectorAll('.break-word')) this.write(text, config[1]);
          wrapper.classList.add('fsx-option-choices');
          let none = wrapper.querySelector('.fsx-option-none');
          if (!none) {
            none = document.createElement('button'); none.type = 'button'; none.className = 'fsx-option-none';
            none.textContent = config[2] + ' · ' + w.included;
            none.addEventListener('click', () => { if (input.checked) label.click(); this.schedule(); });
            wrapper.prepend(none);
          }
          none.setAttribute('aria-pressed', String(!input.checked));
          none.disabled = input.disabled;
          if (!field.querySelector('.fsx-option-help')) {
            const help = document.createElement('p'); help.className = 'fsx-option-help'; help.textContent = config[3];
            wrapper.before(help);
          }
        }
        for (const select of app.querySelectorAll('select[data-type="select"]')) {
          if (select.name.trim().toLowerCase() !== 'badge') continue;
          const empty = Array.from(select.options).find(o => o.value === '');
          if (empty) { empty.disabled = false; this.write(empty, w.no_badge); }
          this.write(select.closest('.gpo-element')?.querySelector('.gpo-label .label-content'), w.badge);
        }
        let total = app.querySelector('.fsx-options-total');
        if (!total) {
          total = document.createElement('div'); total.className = 'fsx-options-total';
          const row = document.createElement('div'); row.className = 'fsx-options-total__row';
          const label = document.createElement('span'); label.textContent = w.total;
          const output = document.createElement('output'); output.setAttribute('aria-live', 'polite');
          const help = document.createElement('p'); help.textContent = w.total_help;
          row.append(label, output); total.append(row, help); app.append(total);
        }
        const raw = app.querySelector('.gpo-total-text .money')?.textContent || '0';
        const clean = raw.replace(/[^0-9,.-]/g, '');
        const extra = Number(clean.includes(',') ? clean.replace(/\./g, '').replace(',', '.') : clean);
        const base = Number(this.dataset.basePrice) / 100;
        if (Number.isFinite(base) && Number.isFinite(extra)) {
          const money = new Intl.NumberFormat(this.dataset.locale || 'fr', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(base + extra);
          this.write(total.querySelector('output'), money);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
